import iphone17 from '../../../assets/BestInCate/iphone17.png';
import iphone17Pro from '../../../assets/BestInCate/iphone17pro.png';
import iphone17e1 from '../../../assets/apple/iPhone17e/iPhone17e_1.png';
import iphone17e2 from '../../../assets/apple/iPhone17e/iPhone17e_2.png';
import iphone17e3 from '../../../assets/apple/iPhone17e/iPhone17e_3.png';
import iphone17e4 from '../../../assets/apple/iPhone17e/iPhone17e_4.png';
import iphoneAir from '../../../assets/apple/iPhoneAir/iPhoneAir1.png';
import iphone13 from '../../../assets/apple/iPhonesBgRemoved/iphone13.jpeg';
import iphone13starlight from '../../../assets/apple/iPhonesBgRemoved/iphone13starlight.jpeg';
import iphone13midnight from '../../../assets/apple/iPhonesBgRemoved/iphone13midnight.jpeg';
import iphone13last from '../../../assets/apple/iPhonesBgRemoved/iphone13last.jpeg';
// DISCONTINUED - Commented out unused imports
// import iphone16pro from '../../../assets/apple/iPhonesBgRemoved/iphone16pro.jpeg';
// import iphone16ProDesertTitanium from '../../../assets/apple/iPhonesBgRemoved/iphone16ProDesertTitanium.jpeg';
// import iphone16ProNaturalTitanium from '../../../assets/apple/iPhonesBgRemoved/iphone16ProNaturalTitanium.jpeg';
// import iphone16ProWhiteTitanium from '../../../assets/apple/iPhonesBgRemoved/iphone16ProWhiteTitanium.jpeg';
// import iphone16ProBlackTitanium from '../../../assets/apple/iPhonesBgRemoved/iphone16ProBlackTitanium.jpeg';
// import iphone16ProLast from '../../../assets/apple/iPhonesBgRemoved/iphone16ProLast.jpeg';
// import iphone16promax from '../../../assets/apple/iPhonesBgRemoved/iphone16promax.jpeg';
import iphone16plus from '../../../assets/apple/iPhonesBgRemoved/iphone16plus.jpeg';
import iphone16 from '../../../assets/apple/iPhonesBgRemoved/iphone16.jpeg';
import iphone16ultramarine from '../../../assets/apple/iPhonesBgRemoved/iphone16ultramarine.jpeg';
import iphone16Black from '../../../assets/apple/iPhonesBgRemoved/iphone16Black.jpeg';
import iphone16White from '../../../assets/apple/iPhonesBgRemoved/iphone16White.jpeg';
import iphone16Teal from '../../../assets/apple/iPhonesBgRemoved/iphone16Teal.jpeg';
import iphone16Pink from '../../../assets/apple/iPhonesBgRemoved/iphone16Pink.jpeg';
import iphone16Last from '../../../assets/apple/iPhonesBgRemoved/iphone16Last.jpeg';
// import iphone15plus from '../../../assets/apple/iPhonesBgRemoved/iphone15plus.jpeg';
import iphone15 from '../../../assets/apple/iPhonesBgRemoved/iphone15.jpeg';
import iphone15Black from '../../../assets/apple/iPhonesBgRemoved/iphone15Black.jpeg';
import iphone15Yellow from '../../../assets/apple/iPhonesBgRemoved/iphone15Yellow.jpeg';
import iphone15Blue from '../../../assets/apple/iPhonesBgRemoved/iphone15Blue.jpeg';
import iphone15Pink from '../../../assets/apple/iPhonesBgRemoved/iphone15Pink.jpeg';
import iphone15Green from '../../../assets/apple/iPhonesBgRemoved/iphone15Green.jpeg';
import iphone15Last from '../../../assets/apple/iPhonesBgRemoved/iphone15Last.jpeg';
// import iphone16e from '../../../assets/apple/iPhonesBgRemoved/iphone16e.jpeg';

const iphone17eImages = [
  iphone17e1,
  iphone17e2,
  iphone17e3,
  iphone17e4,
];

const iphone17eSpecifications = {
  'Display & Design': [
    '6.1-inch Super Retina XDR OLED display with HDR brightness.',
    'Aluminium design with Ceramic Shield 2 and glass back.',
    'IP68 water and dust resistance.',
  ],
  'Performance & OS': [
    'Powered by Apple A19 chip with advanced CPU and Neural Engine.',
    'Runs on iOS 26 with Apple Intelligence features.',
  ],
  Battery: [
    'All-day battery life with efficient power management.',
    'Fast charging up to 50% in around 30 minutes.',
    'MagSafe and wireless charging support.',
  ],
  'Camera & Audio': [
    '48MP Fusion camera with OIS and 2x telephoto capability.',
    '4K Dolby Vision video recording.',
    '12MP front camera for selfies and video calls.',
  ],
  Connectivity: [
    '5G connectivity with faster C1X modem.',
    'Wi-Fi, Bluetooth, and USB-C support.',
  ],
  Features: [
    'Face ID security.',
    'Available storage options: 256GB and 512GB.',
    'MagSafe ecosystem support.',
  ],
};

const iphoneData = [
  {
    id: 1,
    title: 'iPhone 17',
    productImage: iphone17,
    images: [iphone17],
    originalPrice: '99,999',
    discountedPrice: '99,999',
    colors: ['Mist Blue', 'Sage', 'Lavender', 'White', 'Black'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      'Display & Screen': [
        'Super Retina XDR display',
        '15.93 cm / 6.3″ (diagonal) all‑screen OLED display',
        '2622x1206-pixel resolution at 460 ppi',
        'Dynamic Island',
        'Always-On display',
        'ProMotion technology with adaptive refresh rates up to 120Hz',
        'HDR display',
        'True Tone',
        'Wide colour (P3)',
      ],
      'Brightness & Touch': [
        'Haptic Touch',
        '20,00,000:1 contrast ratio (typical)',
        '1,000 nits max brightness (typical); 1,600 nits peak brightness (HDR); 3,000 nits peak brightness (outdoor); 1 nit minimum brightness',
      ],
      'Protection & Finish': [
        'Fingerprint-resistant oleophobic coating',
        'Anti-reflective coating',
      ],
      Support: [
        'Support for display of multiple languages and characters simultaneously',
      ],
    },
  },
  {
    id: 2,
    title: 'iPhone 17 Pro (256GB)',
    productImage: iphone17Pro,
    images: [iphone17Pro],
    originalPrice: '1,34,900',
    discountedPrice: '1,34,900',
    colors: ['Cosmic Orange', 'Deep Blue', 'Silver'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      'Display & Design': [
        '6.3-inch Super Retina XDR OLED display',
        'Dynamic Island, Always-On display',
        'ProMotion adaptive refresh rate up to 120Hz',
        'HDR, True Tone, Wide Color (P3)',
        'Peak brightness up to 3000 nits (outdoor)',
        'Dimensions: 150.0 x 71.9 x 8.75 mm, Weight: 206 g',
        'IP68 water and dust resistance (6m for 30 minutes)',
      ],
      'Performance & Chip': [
        'A19 Pro chip with 6-core CPU, 6-core GPU with Neural Accelerators',
        '16-core Neural Engine',
        'Hardware-accelerated ray tracing',
        'Advanced vapor chamber thermal design',
      ],
      Storage: [
        'Storage: 256GB',
      ],
      'Camera & Video': [
        '48MP Pro Fusion triple-camera: Main, Ultra Wide, Telephoto',
        'Main: 24 mm, ƒ/1.78 with sensor-shift OIS',
        'Telephoto: 48 mm, ƒ/1.78 with sensor-shift OIS',
        'TrueDepth 18MP Center Stage front camera',
      ],
      'Battery & Charging': [
        'Up to 33 hours video playback',
        'Fast charging: Up to 50% in ~20 minutes with USB-C 40W adapter',
        'MagSafe and USB-C charging support',
      ],
      Connectivity: [
        '5G (sub-6 & mmWave), Gigabit LTE',
        'Apple N1 chip: Wi-Fi 7, Bluetooth 6, Thread',
        'Ultra Wideband, NFC, Express Cards with power reserve',
      ],
    },
  },
  {
    id: 9,
    title: 'iPhone 17 Pro (512GB)',
    productImage: iphone17Pro,
    images: [iphone17Pro],
    originalPrice: '1,54,900',
    discountedPrice: '1,54,900',
    colors: ['Cosmic Orange', 'Deep Blue', 'Silver'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      'Display & Design': [
        '6.3-inch Super Retina XDR OLED display',
        'Dynamic Island, Always-On display',
        'ProMotion adaptive refresh rate up to 120Hz',
        'HDR, True Tone, Wide Color (P3)',
        'Peak brightness up to 3000 nits (outdoor)',
        'Dimensions: 150.0 x 71.9 x 8.75 mm, Weight: 206 g',
        'IP68 water and dust resistance (6m for 30 minutes)',
      ],
      'Performance & Chip': [
        'A19 Pro chip with 6-core CPU, 6-core GPU with Neural Accelerators',
        '16-core Neural Engine',
        'Hardware-accelerated ray tracing',
        'Advanced vapor chamber thermal design',
      ],
      Storage: [
        'Storage: 512GB',
      ],
      'Camera & Video': [
        '48MP Pro Fusion triple-camera: Main, Ultra Wide, Telephoto',
        'Main: 24 mm, ƒ/1.78 with sensor-shift OIS',
        'Telephoto: 48 mm, ƒ/1.78 with sensor-shift OIS',
        'TrueDepth 18MP Center Stage front camera',
      ],
      'Battery & Charging': [
        'Up to 33 hours video playback',
        'Fast charging: Up to 50% in ~20 minutes with USB-C 40W adapter',
        'MagSafe and USB-C charging support',
      ],
      Connectivity: [
        '5G (sub-6 & mmWave), Gigabit LTE',
        'Apple N1 chip: Wi-Fi 7, Bluetooth 6, Thread',
        'Ultra Wideband, NFC, Express Cards with power reserve',
      ],
    },
  },
  {
    id: 10,
    title: 'iPhone 17 Pro (1TB)',
    productImage: iphone17Pro,
    images: [iphone17Pro],
    originalPrice: '1,74,900',
    discountedPrice: '1,64,900',
    colors: ['Cosmic Orange', 'Deep Blue', 'Silver'],
    offers: [
      { label: 'Store Discount', value: 'Rs. 10,000' },
      { label: 'Credit Card Cashback', value: 'Rs. 4,000 (Axis / ICICI Credit Card EMI)' },
      { label: 'Exchange Bonus', value: 'Up to Rs. 6,000' },
    ],
    specifications: {
      'Display & Design': [
        '6.3-inch Super Retina XDR OLED display',
        'Dynamic Island, Always-On display',
        'ProMotion adaptive refresh rate up to 120Hz',
        'HDR, True Tone, Wide Color (P3)',
        'Peak brightness up to 3000 nits (outdoor)',
        'Dimensions: 150.0 x 71.9 x 8.75 mm, Weight: 206 g',
        'IP68 water and dust resistance (6m for 30 minutes)',
      ],
      'Performance & Chip': [
        'A19 Pro chip with 6-core CPU, 6-core GPU with Neural Accelerators',
        '16-core Neural Engine',
        'Hardware-accelerated ray tracing',
        'Advanced vapor chamber thermal design',
      ],
      Storage: [
        'Storage: 1TB',
      ],
      'Camera & Video': [
        '48MP Pro Fusion triple-camera: Main, Ultra Wide, Telephoto',
        'Main: 24 mm, ƒ/1.78 with sensor-shift OIS',
        'Telephoto: 48 mm, ƒ/1.78 with sensor-shift OIS',
        'TrueDepth 18MP Center Stage front camera',
      ],
      'Battery & Charging': [
        'Up to 33 hours video playback',
        'Fast charging: Up to 50% in ~20 minutes with USB-C 40W adapter',
        'MagSafe and USB-C charging support',
      ],
      Connectivity: [
        '5G (sub-6 & mmWave), Gigabit LTE',
        'Apple N1 chip: Wi-Fi 7, Bluetooth 6, Thread',
        'Ultra Wideband, NFC, Express Cards with power reserve',
      ],
    },
  },
  {
    id: 13,
    title: 'iPhone 17 Pro Max (256GB)',
    productImage: iphone17Pro,
    images: [iphone17Pro],
    originalPrice: '1,49,900',
    discountedPrice: '1,49,900',
    colors: ['Cosmic Orange', 'Deep Blue', 'Silver'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      'Display & Design': [
        '6.9-inch Super Retina XDR OLED display',
        'Dynamic Island, Always-On display',
        'ProMotion adaptive refresh rate up to 120Hz',
        'HDR, True Tone, Wide Color (P3)',
        'Peak brightness up to 3000 nits (outdoor)',
        'IP68 water and dust resistance (6m for 30 minutes)',
      ],
      'Performance & Chip': [
        'A19 Pro chip with 6-core CPU, 6-core GPU with Neural Accelerators',
        '16-core Neural Engine',
        'Hardware-accelerated ray tracing',
        'Advanced vapor chamber thermal design',
      ],
      Storage: [
        'Storage: 256GB',
      ],
      'Camera & Video': [
        '48MP Pro Fusion triple-camera: Main, Ultra Wide, Telephoto',
        'Main: 24 mm, ƒ/1.78 with sensor-shift OIS',
        'Telephoto: 48 mm, ƒ/1.78 with sensor-shift OIS',
        'TrueDepth 18MP Center Stage front camera',
      ],
      'Battery & Charging': [
        'Up to 37 hours video playback',
        'Fast charging: Up to 50% in ~20 minutes with USB-C 40W adapter',
        'MagSafe and USB-C charging support',
      ],
      Connectivity: [
        '5G (sub-6 & mmWave), Gigabit LTE',
        'Apple N1 chip: Wi-Fi 7, Bluetooth 6, Thread',
        'Ultra Wideband, NFC, Express Cards with power reserve',
      ],
    },
  },
  {
    id: 13,
    title: 'iPhone 17 Pro Max (512GB)',
    productImage: iphone17Pro,
    images: [iphone17Pro],
    originalPrice: '1,69,900',
    discountedPrice: '1,69,900',
    colors: ['Cosmic Orange', 'Deep Blue', 'Silver'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      'Display & Design': [
        '6.9-inch Super Retina XDR OLED display',
        'Dynamic Island, Always-On display',
        'ProMotion adaptive refresh rate up to 120Hz',
        'HDR, True Tone, Wide Color (P3)',
        'Peak brightness up to 3000 nits (outdoor)',
        'IP68 water and dust resistance (6m for 30 minutes)',
      ],
      'Performance & Chip': [
        'A19 Pro chip with 6-core CPU, 6-core GPU with Neural Accelerators',
        '16-core Neural Engine',
        'Hardware-accelerated ray tracing',
        'Advanced vapor chamber thermal design',
      ],
      Storage: [
        'Storage: 512GB',
      ],
      'Camera & Video': [
        '48MP Pro Fusion triple-camera: Main, Ultra Wide, Telephoto',
        'Main: 24 mm, ƒ/1.78 with sensor-shift OIS',
        'Telephoto: 48 mm, ƒ/1.78 with sensor-shift OIS',
        'TrueDepth 18MP Center Stage front camera',
      ],
      'Battery & Charging': [
        'Up to 37 hours video playback',
        'Fast charging: Up to 50% in ~20 minutes with USB-C 40W adapter',
        'MagSafe and USB-C charging support',
      ],
      Connectivity: [
        '5G (sub-6 & mmWave), Gigabit LTE',
        'Apple N1 chip: Wi-Fi 7, Bluetooth 6, Thread',
        'Ultra Wideband, NFC, Express Cards with power reserve',
      ],
    },
  },
  {
    id: 14,
    title: 'iPhone 17 Pro Max (1TB)',
    productImage: iphone17Pro,
    images: [iphone17Pro],
    originalPrice: '1,89,900',
    discountedPrice: '1,79,900',
    colors: ['Cosmic Orange', 'Deep Blue', 'Silver'],
    offers: [
      { label: 'Store Discount', value: 'Rs. 10,000' },
      { label: 'Credit Card Cashback', value: 'Rs. 4,000 (Axis / ICICI Credit Card EMI)' },
      { label: 'Exchange Bonus', value: 'Up to Rs. 6,000' },
    ],
    specifications: {
      'Display & Design': [
        '6.9-inch Super Retina XDR OLED display',
        'Dynamic Island, Always-On display',
        'ProMotion adaptive refresh rate up to 120Hz',
        'HDR, True Tone, Wide Color (P3)',
        'Peak brightness up to 3000 nits (outdoor)',
        'IP68 water and dust resistance (6m for 30 minutes)',
      ],
      'Performance & Chip': [
        'A19 Pro chip with 6-core CPU, 6-core GPU with Neural Accelerators',
        '16-core Neural Engine',
        'Hardware-accelerated ray tracing',
        'Advanced vapor chamber thermal design',
      ],
      Storage: [
        'Storage: 1TB',
      ],
      'Camera & Video': [
        '48MP Pro Fusion triple-camera: Main, Ultra Wide, Telephoto',
        'Main: 24 mm, ƒ/1.78 with sensor-shift OIS',
        'Telephoto: 48 mm, ƒ/1.78 with sensor-shift OIS',
        'TrueDepth 18MP Center Stage front camera',
      ],
      'Battery & Charging': [
        'Up to 37 hours video playback',
        'Fast charging: Up to 50% in ~20 minutes with USB-C 40W adapter',
        'MagSafe and USB-C charging support',
      ],
      Connectivity: [
        '5G (sub-6 & mmWave), Gigabit LTE',
        'Apple N1 chip: Wi-Fi 7, Bluetooth 6, Thread',
        'Ultra Wideband, NFC, Express Cards with power reserve',
      ],
    },
  },
  {
    id: 15,
    title: 'iPhone 17 Pro Max (2TB)',
    productImage: iphone17Pro,
    images: [iphone17Pro],
    originalPrice: '2,09,900',
    discountedPrice: '1,99,900',
    colors: ['Cosmic Orange', 'Deep Blue', 'Silver'],
    offers: [
      { label: 'Store Discount', value: 'Rs. 10,000' },
      { label: 'Credit Card Cashback', value: 'Rs. 4,000 (Axis / ICICI Credit Card EMI)' },
      { label: 'Exchange Bonus', value: 'Up to Rs. 6,000' },
    ],
    specifications: {
      'Display & Design': [
        '6.9-inch Super Retina XDR OLED display',
        'Dynamic Island, Always-On display',
        'ProMotion adaptive refresh rate up to 120Hz',
        'HDR, True Tone, Wide Color (P3)',
        'Peak brightness up to 3000 nits (outdoor)',
        'IP68 water and dust resistance (6m for 30 minutes)',
      ],
      'Performance & Chip': [
        'A19 Pro chip with 6-core CPU, 6-core GPU with Neural Accelerators',
        '16-core Neural Engine',
        'Hardware-accelerated ray tracing',
        'Advanced vapor chamber thermal design',
      ],
      Storage: [
        'Storage: 2TB',
      ],
      'Camera & Video': [
        '48MP Pro Fusion triple-camera: Main, Ultra Wide, Telephoto',
        'Main: 24 mm, ƒ/1.78 with sensor-shift OIS',
        'Telephoto: 48 mm, ƒ/1.78 with sensor-shift OIS',
        'TrueDepth 18MP Center Stage front camera',
      ],
      'Battery & Charging': [
        'Up to 37 hours video playback',
        'Fast charging: Up to 50% in ~20 minutes with USB-C 40W adapter',
        'MagSafe and USB-C charging support',
      ],
      Connectivity: [
        '5G (sub-6 & mmWave), Gigabit LTE',
        'Apple N1 chip: Wi-Fi 7, Bluetooth 6, Thread',
        'Ultra Wideband, NFC, Express Cards with power reserve',
      ],
    },
  },
  {
    id: 11,
    title: 'iPhone 17e (256GB)',
    productImage: iphone17e1,
    images: iphone17eImages,
    originalPrice: '99,999',
    discountedPrice: '99,999',
    colors: ['Soft Pink', 'White', 'Black'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: iphone17eSpecifications,
  },
  {
    id: 12,
    title: 'iPhone 17e (512GB)',
    productImage: iphone17e1,
    images: iphone17eImages,
    originalPrice: '84,900',
    discountedPrice: '84,900',
    colors: ['Soft Pink', 'White', 'Black'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: iphone17eSpecifications,
  },
  {
    id: 4,
    title: 'iPhone Air',
    productImage: iphoneAir,
    images: [iphoneAir],
    originalPrice: '1,49,900',
    discountedPrice: '1,49,900',
    colors: ['Sky Blue', 'Space Black', 'Light Gold', 'Cloud White'],
    offers: [
      { label: 'Store Discount', value: 'Rs. 18,000' },
      {
        label: 'Credit Card Cashback',
        value: 'Rs. 4,000 (Axis / ICICI Credit Card EMI)',
      },
      { label: 'Exchange Bonus', value: 'Up to Rs. 6,000' },
    ],
    specifications: {
      'Performance & Chip': [
        'A19 Pro chipset.',
        '6-core CPU with 2 performance and 4 efficiency cores.',
        '5-core GPU.',
        '16-core Neural Engine.',
        '8GB to 12GB RAM depending on source or model.',
      ],
      Display: [
        '6.5-inch Super Retina XDR OLED display.',
        '2736 x 1260 resolution.',
        'ProMotion refresh rate up to 120Hz.',
        'Brightness up to 3000 nits.',
        'Always-on display with Dynamic Island.',
      ],
      Camera: [
        '48 MP Fusion main rear camera.',
        'Up to 2x optical zoom.',
        '4K video recording on the rear camera.',
        '18 MP front camera with Center Stage support.',
        '4K video recording on the front camera.',
      ],
      'Battery & Charging': [
        'Approx. 3149 mAh battery.',
        'USB-C wired charging.',
        'MagSafe and wireless charging support.',
        'All-day battery life.',
      ],
      Storage: [
        '256GB, 512GB, and 1TB storage options.',
        'No expandable storage.',
      ],
      Connectivity: [
        '5G support.',
        'Wi-Fi 7, Bluetooth 6, and NFC.',
        'GPS and NavIC support.',
        'Dual eSIM with no physical SIM slot.',
      ],
      'Design & Build': [
        'Approx. 5.6 mm ultra-thin design.',
        'Approx. 165g weight.',
        'Titanium build with Ceramic Shield.',
        'IP68 water resistance.',
        'USB-C port.',
      ],
      Software: [
        'iOS 26.',
        'Apple Intelligence, AI tools, and improved privacy features.',
      ],
      Highlights: [
        'Apple thinnest iPhone design at around 5.6 mm.',
        'Flagship A19 Pro performance.',
        'Single camera setup as a lightweight design trade-off.',
        'Focused on lightweight feel and premium materials.',
      ],
    },
  },
  {
    id: 3,
    title: 'iPhone 13',
    productImage: iphone13,
    images: [iphone13starlight, iphone13midnight, iphone13last],
    originalPrice: '49,900',
    discountedPrice: '46,400',
    offerText: 'Flat ₹10,000 off',
    colors: ['Midnight', 'Starlight'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
      // { label: 'Offer', value: 'Get ₹2000 off on HDFC Credit Card' },
      // { label: 'EMI', value: 'Available from ₹1333/month' },
    ],
    specifications: {
      // Display: '6.5" AMOLED, 120Hz',
      // Memory: '8GB RAM, 128GB Storage',
      // Camera: '64MP Rear, 32MP Front',
      // Battery: '5000mAh, Fast Charging',
      // 'Other Specs': {
      // Specs: {
      //   Processor: 'Snapdragon 8 Gen 2',
      //   OS: 'Android 13',
      //   Weight: '180g',
      //   Dimensions: '160 x 75 x 8 mm',
      //   Connectivity: '5G, Wi-Fi 6, Bluetooth 5.2',
      //   SIM: 'Dual SIM (Nano)',
      // },
      Specs: [
        '(6.1") Super Retina XDR display',
        'A15 Bionic Chip',
        '12 MP Main Camera',
        'Upto 19 hours video playback',
        'Superfast 5G Cellular',
        'Available Storage - 128GB',
      ],
    },
  },
  // DISCONTINUED MODELS - Commented out
  // {
  //   id: 2,
  //   title: 'iPhone 16 Pro',
  //   productImage: iphone16pro,
  //   images: [
  //     iphone16pro,
  //     iphone16ProDesertTitanium,
  //     iphone16ProNaturalTitanium,
  //     iphone16ProWhiteTitanium,
  //     iphone16ProBlackTitanium,
  //     iphone16ProLast,
  //   ],
  //   originalPrice: '1,19,900',
  //   discountedPrice: '1,09,900',
  //   colors: [
  //     'Desert Titanium',
  //     'Black Titanium',
  //     'Natural Titanium',
  //     'White Titanium',
  //   ],
  //   offers: [
  //     { label: 'Offer', value: '(Inclusive of credit card offers)' },
  //   ],
  //   specifications: {
  //     Specs: [
  //       '(6.3") Super Retina XDR display. Pro Motion technology.',
  //       'A18 Pro Bionic Chip',
  //       'Dynamic Island',
  //       'Camera Control',
  //       '48 MP Fusion. 48MP Ultra Wide. Telephoto.',
  //       'Upto 27 hours video playback',
  //       'Superfast 5G Cellular',
  //       'Available Storage - 128GB, 256GB, 512GB, 1TB',
  //     ],
  //   },
  // },
  // {
  //   id: 3,
  //   title: 'iPhone 16 Pro Max',
  //   productImage: iphone16promax,
  //   images: [iphone16promax],
  //   originalPrice: '1,44,900',
  //   discountedPrice: '1,34,900',
  //   colors: [
  //     'Desert Titanium',
  //     'Black Titanium',
  //     'Natural Titanium',
  //     'White Titanium',
  //   ],
  //   offers: [
  //     { label: 'Offer', value: '(Inclusive of credit card offers)' },
  //   ],
  //   specifications: {
  //     Specs: [
  //       '(6.9") Super Retina XDR display. Pro Motion technology.',
  //       'A18 Pro Bionic Chip',
  //       'Dynamic Island',
  //       'Camera Control',
  //       '48 MP Fusion. 48MP Ultra Wide. Telephoto.',
  //       'Upto 33 hours video playback',
  //       'Superfast 5G Cellular',
  //       'Available Storage - 128GB, 256GB, 512GB, 1TB',
  //     ],
  //   },
  // },
  {
    id: 6,
    title: 'iPhone 16 Plus',
    productImage: iphone16plus,
    images: [iphone16plus],
    originalPrice: '79,900',
    discountedPrice: '74,900',
    // offerText: 'Flat ₹10,000 off',
    colors: ['Ultramarine', 'Teal', 'Pink', 'White', 'Black'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
      // { label: 'Offer', value: 'Get ₹2000 off on HDFC Credit Card' },
      // { label: 'EMI', value: 'Available from ₹1333/month' },
    ],
    specifications: {
      // Display: '6.5" AMOLED, 120Hz',
      // Memory: '8GB RAM, 128GB Storage',
      // Camera: '64MP Rear, 32MP Front',
      // Battery: '5000mAh, Fast Charging',
      Specs: [
        '(6.7") Super Retina XDR display',
        'A18 Bionic Chip',
        'Dynamic Island',
        'Camera Control',
        '48 MP Fusion Camera',
        'Upto 27 hours video playback',
        'Superfast 5G Cellular',
        'Available Storage - 128GB, 256GB, 512GB',
      ],
    },
  },
  {
    id: 5,
    title: 'iPhone 16 (128GB)',
    productImage: iphone16,
    images: [
      iphone16,
      iphone16ultramarine,
      iphone16Black,
      iphone16White,
      iphone16Teal,
      iphone16Pink,
      iphone16Last,
    ],
    originalPrice: '89,900',
    discountedPrice: '89,900',
    colors: ['Ultramarine', 'Pink', 'Teal', 'White', 'Black'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Specs: [
        '(6.1") Super Retina XDR display',
        'A18 Bionic Chip',
        'Dynamic Island',
        'Camera Control',
        '48 MP Fusion Camera',
        'Upto 22 hours video playback',
        'Superfast 5G Cellular',
        'Storage - 128GB',
      ],
    },
  },
  // {
  //   id: 6,
  //   title: 'iPhone 15 Plus',
  //   productImage: iphone15plus,
  //   images: [iphone15plus],
  //   originalPrice: '79,900',
  //   discountedPrice: '71,900',
  //   colors: ['Pink', 'Yellow', 'Green', 'Blue', 'Black'],
  //   offers: [
  //     { label: 'Offer', value: '(Inclusive of credit card offers)' },
  //   ],
  //   specifications: {
  //     Specs: [
  //       '(6.7") Super Retina XDR display',
  //       'A16 Bionic Chip',
  //       'Dynamic Island',
  //       '48 MP Main Camera',
  //       'Upto 26 hours video playback',
  //       'Superfast 5G Cellular',
  //       'Available Storage - 128GB, 256GB',
  //     ],
  //   },
  // },
  {
    id: 7,
    title: 'iPhone 15 (128GB)',
    productImage: iphone15,
    images: [
      iphone15,
      iphone15Black,
      iphone15Yellow,
      iphone15Blue,
      iphone15Pink,
      iphone15Green,
      iphone15Last,
    ],
    originalPrice: '79,500',
    discountedPrice: '79,500',
    colors: ['Pink', 'Yellow', 'Green', 'Blue', 'Black'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Specs: [
        '(6.1") Super Retina XDR display',
        'A16 Bionic Chip',
        'Dynamic Island',
        '48 MP Main Camera',
        'Upto 20 hours video playback',
        'Superfast 5G Cellular',
        'Storage - 128GB',
      ],
    },
  },
  {
    id: 8,
    title: 'iPhone 15 (256GB)',
    productImage: iphone15,
    images: [
      iphone15,
      iphone15Black,
      iphone15Yellow,
      iphone15Blue,
      iphone15Pink,
      iphone15Green,
      iphone15Last,
    ],
    originalPrice: '69,900',
    discountedPrice: '69,900',
    colors: ['Pink', 'Yellow', 'Green', 'Blue', 'Black'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Specs: [
        '(6.1") Super Retina XDR display',
        'A16 Bionic Chip',
        'Dynamic Island',
        '48 MP Main Camera',
        'Upto 20 hours video playback',
        'Superfast 5G Cellular',
        'Storage - 256GB',
      ],
    },
  },
  // {
  //   id: 8,
  //   title: 'iPhone 16e',
  //   productImage: iphone16e,
  //   images: [iphone16e],
  //   originalPrice: '59,900',
  //   discountedPrice: '50,900',
  //   colors: ['Black', 'White'],
  //   offers: [
  //     { label: 'Offer', value: '(Inclusive of credit card offers)' },
  //   ],
  //   specifications: {
  //     Specs: [
  //       '(6.1") Super Retina XDR display',
  //       'A18 Bionic Chip',
  //       '48 MP Fusion Camera',
  //       'Upto 26 hours video playback',
  //       'Superfast 5G Cellular',
  //       'Available Storage - 128GB, 256GB',
  //     ],
  //   },
  // },
];

export default iphoneData;
